module.exports = __webpack_public_path__ + "7e1949c46468f8d7b44d16b10487454c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzak-4.jpg
// module id = 1186
// module chunks = 0